import React from 'react';

import {faTimes} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Button} from '@newsela/angelou';
import {css} from 'emotion';
import PropTypes from 'prop-types';

import uiColors from 'components/Colors/colors';
import {providerImages, SUPPORTED_AUTH_PROVIDERS} from 'modulesV2/utils/onboardingUtils';
import Modal from 'static/three-oh/src/components/Modal/Modal';




const containerStyles = css`
  display: flex;
  flex-direction: row;

  @media only screen and (max-width: 860px) {
    flex-direction: column-reverse;
  }
`;

const imageStyles = css`
  width: 600px;
  max-width: 600px;
  min-height: 500px;
  background-size: 350px;
  align-self: center;
  background-repeat: no-repeat;
  background-position: center;

  @media only screen and (max-width: 1005px) and (min-width: 861px) {
    width: 460px;
  }

  @media only screen and (max-width: 860px) {
    min-height: 300px;
    background-size: 250px;
    width: 100%;
  }
`;

const ctaContainer = css`
  width: 400px;
  background-color: ${uiColors.black[0]};
  padding: 15px 24px 24px 24px;
  display: flex;
  flex-direction: column;

  @media only screen and (max-width: 860px) {
    width: 100%;
  }
`;

const ctaStyles = css`
  color: ${uiColors.white[0]};
  font-size: 30px;
  flex-grow: 1;
  margin-bottom: 50px;
`;

const closeIcon = css`
  text-align: right;
  font-size: 25px;
  color: ${uiColors.grey_light[1]}
`;

const actionButtons = css`
  display: flex;
  justify-content: flex-end;
  > button {
    font-size: 16px;
  }
`;

const syncButtonStyles = `
  cursor: pointer;
`;

const skipButtonStyles = `
  cursor: pointer;
  text-decoration: none;
  margin-right: 35px;
`;


const propTypes = {
  actions: PropTypes.shape({
    syncClasses: PropTypes.func.isRequired,
    skipSync: PropTypes.func.isRequired,
  }),
  authProvider: PropTypes.oneOf([
    ...SUPPORTED_AUTH_PROVIDERS,
    'forms', 'sign_in_as_user',
  ]).isRequired,
  isOpen: PropTypes.bool.isRequired,
};

class WelcomeBackModal extends React.PureComponent {
  getProviderImage = () => {
    const {authProvider} = this.props;
    if (authProvider in providerImages) {
      return providerImages[authProvider];
    }
    return '';
  };

  render() {
    const {syncClasses, skipSync} = this.props.actions;
    return (
      <Modal
        className={css`max-width: fit-content`}
        centered
        open={this.props.isOpen}
        onClose={skipSync}
        transition="popIn"
      >
        <div className={containerStyles}>
          <div
            className={css`
              ${imageStyles};
              background-image: url(${this.getProviderImage()});
            `}
          />
          <div className={ctaContainer}>
            <div className={ctaStyles}>
              <div className={closeIcon}>
                <FontAwesomeIcon
                  className={css`cursor: pointer;`}
                  icon={faTimes}
                  onClick={skipSync}
                />
              </div>
              <div className={css`font-weight: bold;`}>
                Start Assigning Articles
              </div>
              <div className={css`font-size: 20px; margin-top: 14px;`}>
                To assign articles to your students, first sync your classes on your Class Settings page.
              </div>
            </div>
            <div className={actionButtons}>
              <Button
                flavor={Button.flavor.link}
                __cssFor={{
                  root: skipButtonStyles
                }}
                onClick={skipSync}
              >
                Not now
              </Button>
              <Button
                flavor={Button.flavor.solid}
                statusColor={Button.statusColor.primary}
                __cssFor={{
                  root: syncButtonStyles
                }}
                onClick={syncClasses}
              >
                Sync classes
              </Button>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

WelcomeBackModal.propTypes = propTypes;
export default WelcomeBackModal;
